import { render, staticRenderFns } from "./ConnectedUsersDialog.vue?vue&type=template&id=45f20f38&scoped=true&"
import script from "./ConnectedUsersDialog.vue?vue&type=script&lang=js&"
export * from "./ConnectedUsersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f20f38",
  null
  
)

export default component.exports